"use client";

import { Translation } from "@/data/lang";

import { ButtonGroupOption } from "ui/core/button-group";

export const getCategoryOptions = ({
  t,
}: {
  t: Translation;
}): ButtonGroupOption[] => [
  {
    label: `${t.analysis.value.forecast.eps}${t.analysis.value.forecast.forecast}`,
    value: "eps",
  },
  {
    label: `${t.analysis.value.forecast.revenue}${t.analysis.value.forecast.forecast}`,
    value: "revenue",
  },
];
